export default __webpack_public_path__ + "static/media/Bandit's Gloves of the Wicked Hearth.4fa5b9ae.jpg";